<!-- src/components/Button.vue -->

<template>
    <a
        @click="didClick"
        class="button"
        :class="[type]">
        <span class="button-icon" :class="[icon]"></span>
        <slot></slot>
    </a>
</template>

<script>
    
export default {
    props: [ "type", "icon" ],
    
    methods: {
        didClick ($event) {
            this.$emit("click", $event)
        }
    },
}
</script>

<style>
.button {
    background: #FFF;
    font-family: var(--font-family);
    font-weight: 500;
    font-size: 14px;
    line-height: 14px;
    color: #4A4A4A;
    letter-spacing: 0;
    border: 1px solid #DDD;
    border-radius: 5px;
    display: inline-block;
    text-decoration: none;
    padding: 7px 12px;
    margin: 5px inherit;
    cursor: pointer;
    vertical-align: middle;
}

.button:hover {
    background: #DDD;
    color: #555;
    border: 1px solid #CCC;
}

.button:active {
    border-color: #BBB;
    background: #CCC;
}

.button.large {
    padding: 12px 12px;
}

.button.small {
    font-size: 12px;
    padding: 5px 10px;
}

.button.red,
.button.danger {
    color: #FF001F;
}

.button.green,
.button.success {
    background: #81B920;
    color: #FFF;
    border-color: #81B920;
}

.button.green:hover,
.button.success:hover {
    border-color: #30965C;
    background: #30965C;
}

.button.clear {
    background: transparent;
    color: #A4A4A4;
    border-color: transparent;
    padding-left: 0px;
    padding-right: 0px;
}

.button.clear:hover {
    color: #333;
}

.button .button-icon {
    margin-right: 3px;
}

.button .button-icon:before {
    vertical-align: bottom;
}

.button.icon-right .button-icon {
    float: right;
    margin-left: 3px;
    margin-right: 0px;
}

.button .spinner {
    width: 10px;
    height: 10px;
    display: inline-block;
    margin-left: 3px;
    margin-right: 3px;
    position: relative;
}
</style>
